import React from 'react';
import {connect, useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Trans} from 'react-i18next';
import {API_ROOT, APP_URL} from '../../../../../../utils';
import Icon from '../../../../../../components/icon';
import Button from '../../../../../../components/button';
import {postEngagement} from '../../../../../../../actions/engagementActions';

const InvalidSharingPopupMessage = (props) => {

	const {t} = useTranslation();

	const dispatch = useDispatch();

	const windowCloseIfGmailAddOnPopup = () => {
		if (props.checkGAddon === 'gmailaddon') {
			window.close();
		}
	};

	const handleUpgrade = () => {
		dispatch(postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format()));
	};

	switch (props.error) {
		case 'BASIC_USER_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Basic'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Basic'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Enterprise'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   target="_blank" rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'LITE_USER_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Lite'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Lite'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'BASIC_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Basic'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Basic'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Enterprise'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   target="_blank" rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'LITE_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Lite'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Lite'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'BASIC_DOMAIN_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Basic'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Basic'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Enterprise'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   target="_blank" rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'LITE_DOMAIN_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Lite'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Lite'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'PRO_DOMAIN_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" color="#c00"/> <span className="text-danger">{t('upgradeText')}</span>
					</h2>
					<p>You cannot share your label to a group of collaborators on PRO version for Shared Contacts for
						Gmail®.</p>
					<div className="text-right">
						<a onClick={props.close} role="button" className="btn btn-default text-white"
						   href={`${API_ROOT}/payment/upgrade`} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'EXTERNAL_USER_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Basic'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Basic'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Enterprise'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   target="_blank" rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'LITE_EXTERNAL_USER_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Lite'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Lite'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
						<li>{t('textUpgradeContent5')}</li>
						<li>{t('textUpgradeContent6')}</li>
						<li>{t('textUpgradeContent7')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'TEAM_EXTERNAL_USER_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Team'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Team'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'TEAM_DOMAIN_GROUP_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textUpgradeContent" values={{plan_name: 'Team'}}/></p>
					<p><Trans i18nKey="textUpgradeContent2" values={{plan_name: 'Team'}}/></p>
					<ul>
						<li>{t('textUpgradeContent3')}.</li>
						<li>{t('textUpgradeContent4')}</li>
					</ul>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					<p><Trans i18nKey="textUpgradeContent9" values={{plan_name: 'Business'}}/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/payment/upgrade`}
						   onClick={windowCloseIfGmailAddOnPopup} target="_blank"
						   rel="noreferrer">{t('textUpgradeNow')}!</a>
					</div>
				</div>
			);
		case 'LICENSES_LIMIT':
			return (
				<div className="p-4">
					<h2><Icon name="user-times" color="#c00"/> <span
						className="text-danger">{t('expiredLincencesText1')}</span></h2>
					<p>{t('expiredLincencesText2')}.</p>
					<div className="text-right">
						<a onClick={props.close} role="button" className="btn btn-default text-white"
						   href={`${API_ROOT}/payment/add`} target="_blank"
						   rel="noreferrer">{t('updateLincencesText')}</a>
					</div>
				</div>
			);
		case 'SELF_SHARING_NOT_ALLOWED':
			return (
				<div className="p-4">
					<h2><Icon name="chain-broken" color="#c00"/> <span className="text-danger">{t('errorText')}</span>
					</h2>
					<p>{t('textSelfSharing')}.</p>
					<div className="text-right">
						<button onClick={props.close} className="btn btn-default text-white">{t('okText')}</button>
					</div>
				</div>
			);
		case 'INTERNAL_USER_INVITED':
			return (
				<div className="p-4">
					<h2><Icon name="clock-o" color="#ffc107"/> <span className="text-warning">Invitation sent</span>
					</h2>
					<p>{t('textAbnormalUser')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'EXTERNAL_USER_INVITED':
			return (
				<div className="p-4">
					<h2><Icon name="clock-o" color="#ffc107"/> <span className="text-warning">Invitation sent</span>
					</h2>
					<p>{t('textExternalUserInvited')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'USER_IS_BANNED':
			return (
				<div className="p-4">
					<h2><Icon name="gavel" color="#c00"/> <span className="text-danger">{t('textBannedTitle')}</span>
					</h2>
					<p><Trans i18nKey="textBannedContent"
					          components={{a: <a href='https://support.google.com/a/answer/1047213'> </a>}}/></p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'USER_IS_DELETED':
			return (
				<div className="p-4">
					<h2><Icon name="user-times" color="#c00"/> <span
						className="text-danger">{t('textDeletedTitle')}</span></h2>
					<p><Trans i18nKey="textDeletedContent" components={{
						a: <a
							href='https://www.getsharedcontacts.com/knowledge-base/how-to-free-up-or-reduce-your-licenses/'> </a>
					}}/></p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'USER_IS_REVOKED':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" color="#c00"/> <span
						className="text-danger">{t('textRevokedTitle')}</span></h2>
					<p>{t('textRevokedContent')}</p>
					<ul>
						<li><Trans i18nKey="textRevokedContent2" components={{
							a: <a
								href='https://www.getsharedcontacts.com/knowledge-base/how-to-accept-an-invitation-to-access-a-shared-label/'> </a>
						}}/> <Button onClick={props.resend}
						             className="d-block btn-link mt-2 mr-0 ml-auto mb-3">&raquo; {t('ressendInviteText2')}</Button>
						</li>
						<li>{t('textRevokedContent3')}</li>
					</ul>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'USER_SUSPENDED':
			return (
				<div className="p-4">
					<h2><Icon name="minus-circle" color="#c00"/> <span
						className="text-danger">{t('textSuspendTitle')}</span></h2>
					<p><Trans i18nKey="textSuspendContent"
					          components={{i: <i style={{paddingLeft: 2, paddingRight: 2}}/>}}/></p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'NOT_FOUND':
			return (
				<div className="p-4">
					<h2><Icon name="minus-circle" color="#c00"/> <span
						className="text-danger">{t('textNotFound2')}</span></h2>
					<p>{t('textNotFound1')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-default text-white">{t('okText')}</Button>
					</div>
				</div>
			);
		case 'INVALID_PAYMENT_STATUS':
			return (
				<div className="p-4">
					<h2><Icon name="level-up" className="text-danger"/> <span
						className="text-danger">{t('textUpgradeTitle')}</span></h2>
					<p><Trans i18nKey="textInvalidPayment" values={{plan_name: 'TRIAL or PAID'}}/></p>
					<hr/>
					<h3>{t('textUpgradeContent8')}</h3>
					{/* <p>You can benefit of our <strong>15 days Free trial</strong> <small>(no credit card required)</small> to access all the features.</p> */}
					<p><Trans i18nKey="textInvalidPaymentStatus1"/></p>
					<div className="text-right">
						<a role="button" className="btn btn-default text-white" href={`${API_ROOT}/account/try`}
						   target="_blank" rel="noreferrer">{t('textTryNow')}!</a>
					</div>
				</div>
			);
		case 'READ_ONLY_GROUP':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Read only group</span>
					</h2>
					<p>{t('invalidSharingReadOnlyGroup')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'GROUP_NOT_FOUND':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Label not found</span>
					</h2>
					<p>
						<Trans i18nKey="invalidSharingGroupNotFound" components={{
							a: <a href='mailto:support@getsharedcontacts.com'> </a>
						}}/>
					</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'PERMISSION_DENIED':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Share permission not found</span>
					</h2>
					<p>{t('invalidSharingPermissionDenied')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'ACTION_RESTRICTED_DIRECTORY_NOT_SHARED':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Action restricted: Directory not shared</span>
					</h2>
					<p>
						<Trans
							i18nKey="invalidSharingActionRestrictedDirectoryNotShared"
							values={{ownerName: props.selectedContactsGroup.ownerName}}
						/>
					</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'ENABLE_DIRECTORY_SYNC':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Action restricted: Directory not synced</span>
					</h2>
					<p>{t('invalidSharingEnableDirectorySync')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'ASK_ADMIN_TO_ENABLE_DIRECTORY_SYNC_AND_SHARE_DIRECTORY_LABEL':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Action restricted: Directory not synced</span>
					</h2>
					<p>{t('invalidSharingAskAdminToEnableDirectorySyncAndShareDirectoryLabel')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'ASK_ADMIN_TO_SHARE_DIRECTORY_LABEL':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">Action restricted: Directory not shared</span>
					</h2>
					<p>{t('invalidSharingAskAdminToShareDirectoryLabel')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'SHARING_LIMIT_EXCEEDED':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{t('sharingErrorTitle')}</span>
					</h2>
					<p>{t('sharingErrorSharingLimitExceededContent')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'SHARING_LIMIT_EXCEEDED_BY_FREEMIUM':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{t('sharingErrorTitle')}</span>
					</h2>
					<p>{t('sharingLimitExceededByFreemiumContent')}</p>
					<div className="text-right">
						<Button onClick={ handleUpgrade } className="btn-primary text-white">{t("upgradeToBusinessBtn")}</Button>
					</div>
				</div>
			);
		case 'NO_OF_CONTACT_LIMIT_EXCEEDED_BY_FREEMIUM':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{t('sharingErrorTitle')}</span>
					</h2>
					<p>{t('noOfContactLimitExceededByFreemiumContent')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		case 'DOMAIN_GROUP_SHARING_NOT_ALLOWED_BY_FREEMIUM':
			return (
				<div className="p-4">
					<h2><Icon name="times-circle" className="text-danger"/> <span className="text-danger">{t('sharingErrorTitle')}</span>
					</h2>
					<p>{t('domainGroupSharingNotAllowedByFreemiumContent')}</p>
					<div className="text-right">
						<Button onClick={props.close} className="btn-primary text-white">{t("okText")}</Button>
					</div>
				</div>
			);
		default:
			return (
				<div className="p-4">
					<h2>{t('textUnkownError')}</h2>
					<p><Trans i18nKey="textInvalidStatusForAttachment"
					          components={{a: <a href={`${APP_URL}/support`}> </a>}}/></p>
				</div>
			);
	}
};

const mapStateToProps = (state) => ({
	checkGAddon: state.profileReducer.setGmailAddOnData.checkGmailAddon,
	selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
});

export default connect(mapStateToProps, '')(InvalidSharingPopupMessage);

